{
  "about.blocks": "நடுநிலையான சேவையகங்கள்",
  "about.contact": "தொடர்பு:",
  "about.disclaimer": "மாஸ்டோடன் இலவச, திறந்த மூல மென்பொருள் மற்றும் மாஸ்டோடன் gGmbH இன் வர்த்தக முத்திரை.",
  "about.domain_blocks.no_reason_available": "காரணம் கிடைக்கவில்லை",
  "about.domain_blocks.preamble": "மாஸ்டோடன் பொதுவாக நீங்கள் ஃபெடிவர்ஸில் உள்ள வேறு எந்தச் சர்வரிலிருந்தும் உள்ளடக்கத்தைப் பார்க்கவும், பயனர்களுடன் தொடர்பு கொள்ளவும் அனுமதிக்கிறது. இந்தக் குறிப்பிட்ட சர்வரில் செய்யப்பட்ட விதிவிலக்குகள் இவை.",
  "account.add_or_remove_from_list": "பட்டியல்களில் சேர்/நீக்கு",
  "account.badges.bot": "பாட்",
  "account.badges.group": "குழு",
  "account.block": "@{name} -ஐத் தடு",
  "account.block_domain": "{domain} யில் இருந்து வரும் எல்லாவற்றையும் மறை",
  "account.block_short": "தடு",
  "account.blocked": "முடக்கப்பட்டது",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.disable_notifications": "@{name} பதிவிட்டல் எனக்கு தெரியபடுத்த வேண்டாம்",
  "account.edit_profile": "சுயவிவரத்தை மாற்று",
  "account.enable_notifications": "@{name} பதிவிட்டல் எனக்குத் தெரியப்படுத்தவும்",
  "account.endorse": "சுயவிவரத்தில் வெளிப்படுத்து",
  "account.follow": "பின்தொடர்",
  "account.follow_back": "பின்தொடரு",
  "account.followers": "பின்தொடர்பவர்கள்",
  "account.followers.empty": "இதுவரை யாரும் இந்த பயனரைப் பின்தொடரவில்லை.",
  "account.following": "பின்தொடரும்",
  "account.follows.empty": "இந்த பயனர் இதுவரை யாரையும் பின்தொடரவில்லை.",
  "account.go_to_profile": "சுயவிவரத்திற்குச் செல்லவும்",
  "account.hide_reblogs": "இருந்து ஊக்கியாக மறை @{name}",
  "account.link_verified_on": "இந்த இணைப்பை உரிமையாளர் சரிபார்க்கப்பட்டது {date}",
  "account.locked_info": "இந்தக் கணக்கு தனியுரிமை நிலை பூட்டப்பட்டுள்ளது. அவர்களைப் பின்தொடர்பவர் யார் என்பதை உரிமையாளர் கைமுறையாக மதிப்பாய்வு செய்கிறார்.",
  "account.media": "ஊடகங்கள்",
  "account.mention": "குறிப்பிடு @{name}",
  "account.mute": "ஊமையான @{name}",
  "account.mute_notifications_short": "அறிவிப்புகளை ஒலியடக்கு",
  "account.mute_short": "அமைதியாக்கு",
  "account.muted": "முடக்கியது",
  "account.no_bio": "விளக்கம் எதுவும் வழங்கப்படவில்லை.",
  "account.posts": "டூட்டுகள்",
  "account.report": "@{name} -ஐப் புகாரளி",
  "account.share": "@{name} உடைய விவரத்தை பகிர்",
  "account.show_reblogs": "காட்டு boosts இருந்து @{name}",
  "account.unblock": "@{name} மீது தடை நீக்குக",
  "account.unblock_domain": "{domain} ஐ காண்பி",
  "account.unblock_short": "தடையை நீக்கு",
  "account.unendorse": "சுயவிவரத்தில் இடம்பெற வேண்டாம்",
  "account.unfollow": "பின்தொடர்வதை நிறுத்துக",
  "account.unmute": "@{name} இன் மீது மௌனத் தடையை நீக்குக",
  "account.unmute_short": "அமைதியை நீக்கு",
  "account_note.placeholder": "குறிப்பு ஒன்றை சேர்க்க சொடுக்கவும்",
  "admin.dashboard.daily_retention": "பதிவுசெய்த பிறகு நாள்தோறும் பயனர் தக்கவைப்பு விகிதம்",
  "admin.dashboard.monthly_retention": "பதிவுசெய்த பிறகு மாதந்தோறும் பயனர் தக்கவைப்பு விகிதம்",
  "admin.dashboard.retention.average": "சராசரி",
  "admin.dashboard.retention.cohort": "பதிவுசெய்த மாதம்",
  "admin.dashboard.retention.cohort_size": "புதிய பயனர்கள்",
  "alert.rate_limited.message": "{retry_time, time, medium} க்கு பிறகு மீண்டும் முயற்சிக்கவும்.",
  "alert.rate_limited.title": "பயன்பாடு கட்டுப்படுத்தப்பட்டுள்ளது",
  "alert.unexpected.message": "எதிர்பாராத பிழை ஏற்பட்டுவிட்டது.",
  "alert.unexpected.title": "அச்சச்சோ!",
  "announcement.announcement": "அறிவிப்பு",
  "attachments_list.unprocessed": "(செயலாக்கப்படாதது)",
  "audio.hide": "ஆடியோவை மறை",
  "boost_modal.combo": "நீங்கள் இதை அடுத்தமுறை தவிர்க்க {combo} வை அழுத்தவும்",
  "bundle_column_error.error.title": "அடடே!",
  "bundle_column_error.network.body": "இந்தப் பக்கத்தைத் திறக்கும்பொழுது ஒரு பிழை ஏற்பட்டுவிட்டது. இது உங்கள் இணைய தொடர்பில் அல்லது இப்பத்தின் வழங்க்கியில் ஏற்பட்டுள்ள ஒரு தற்காலிக பிரச்சணையாக இருக்கலாம்.",
  "bundle_column_error.network.title": "பிணையப் பிழை",
  "bundle_column_error.retry": "மீண்டும் முயற்சிக்கவும்",
  "bundle_column_error.return": "முகப்பிற்கு செல்லவும்",
  "bundle_column_error.routing.body": "கேட்கப்பட்ட பக்கத்தைக் காணவில்லை. நீங்கள் உள்ளிட்ட முகவரி சரியனதா?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "மூடுக",
  "bundle_modal_error.retry": "மீண்டும் முயற்சி செய்",
  "closed_registrations.other_server_instructions": "மேச்டடான் இரு பரவலாக்கப்பட்ட மென்பொருள் என்பதால், நீங்கள் வேரு ஒரு வழங்கியில் கணக்கை உருவாக்கியிருந்தாலும் இந்த வழங்கியில் பயன்படுத்தலாம்.",
  "closed_registrations_modal.description": "{domain} இல் இப்பொழுது கணக்குகள் உருவாக்க முடியாது. நீங்கள் மேச்டடான் பயன்படுத்த, குறிப்பாக {domain} முகவரியில் கணக்கைத் துவங்க வேண்டும் என்ற அவசியமில்லை என்பதை மனதில் வைத்துக் கொள்ளவும்.",
  "closed_registrations_modal.find_another_server": "வேறொரு வழங்கியைக் கண்டுபிடி",
  "closed_registrations_modal.preamble": "மேச்டடான் ஒரு பரவலாக்கப்பட்ட மென்பொருள். ஆதனால் நீங்கள் எங்குக் கணக்கை உருவாக்கினாலும் இந்த வழங்கியில் உள்ள யாருடன் வேண்டும் என்றாலும் உரவாடலாம். நீங்களே கூட ஒரு வழங்கியை நிறுவலாம்!",
  "closed_registrations_modal.title": "மேச்டடான் கணக்கு துவங்கப்படுகிறது",
  "column.about": "பற்றி",
  "column.blocks": "தடுக்கப்பட்ட பயனர்கள்",
  "column.bookmarks": "அடையாளக்குறிகள்",
  "column.community": "சுய நிகழ்வு காலவரிசை",
  "column.direct": "தனிப்பட்ட குறிப்புகள்",
  "column.directory": "சுயவிவரங்களை உலாவு",
  "column.domain_blocks": "மறைந்திருக்கும் திரளங்கள்",
  "column.favourites": "பிடித்தவை",
  "column.follow_requests": "பின்தொடர அனுமதிகள்",
  "column.home": "முகப்பு",
  "column.lists": "பட்டியல்கள்",
  "column.mutes": "மௌனத் தடை செய்யப்பட்ட பயனர்கள்",
  "column.notifications": "அறிவிப்புகள்",
  "column.pins": "பொருத்தப்பட்ட டூட்டுகள்",
  "column.public": "ஆலமரத்தில் நிகழ்பவை",
  "column_back_button.label": "பின்செல்",
  "column_header.hide_settings": "அமைப்புகளை மறை",
  "column_header.moveLeft_settings": "நெடுவரிசையை இடதுபுறமாக நகர்த்து",
  "column_header.moveRight_settings": "நெடுவரிசையை வலதுபுறமாக நகர்த்து",
  "column_header.pin": "பொருத்து",
  "column_header.show_settings": "அமைப்புகளைக் காட்டு",
  "column_header.unpin": "கழட்டு",
  "community.column_settings.local_only": "அருகிலிருந்து மட்டுமே",
  "community.column_settings.media_only": "படங்கள் மட்டுமே",
  "community.column_settings.remote_only": "தொலைவிலிருந்து மட்டுமே",
  "compose.language.change": "மொழியை மாற்று",
  "compose.language.search": "தேடல் மொழிகள்...",
  "compose.published.body": "பதிவிடப்பட்டது.",
  "compose.published.open": "திற",
  "compose.saved.body": "பதிவு சேமிக்கப்பட்டது.",
  "compose_form.direct_message_warning_learn_more": "மேலும் அறிய",
  "compose_form.encryption_warning": "Mastodonல் உள்ள பதிவுகள் முறையாக என்க்ரிப்ட்(encrypt) செய்யபடவில்லை. அதனால் முக்கிய தகவல்களை இங்கே பகிர வேண்டாம்.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "உங்கள் கணக்கு {locked} செய்யப்படவில்லை. உங்கள் பதிவுகளை யார் வேண்டுமானாலும் பின்தொடர்ந்து காணலாம்.",
  "compose_form.lock_disclaimer.lock": "பூட்டப்பட்டது",
  "compose_form.placeholder": "உங்கள் மனதில் என்ன இருக்கிறது?",
  "compose_form.poll.duration": "கருத்துக்கணிப்பின் கால அளவு",
  "compose_form.poll.switch_to_multiple": "பல தேர்வுகளை அனுமதிக்குமாறு மாற்று",
  "compose_form.poll.switch_to_single": "ஒரே ஒரு தேர்வை மட்டும் அனுமதிக்குமாறு மாற்று",
  "compose_form.spoiler.marked": "எச்சரிக்கையின் பின்னால் பதிவு மறைக்கப்பட்டுள்ளது",
  "compose_form.spoiler.unmarked": "பதிவு மறைக்கப்படவில்லை",
  "confirmation_modal.cancel": "ரத்து",
  "confirmations.block.confirm": "தடு",
  "confirmations.delete.confirm": "நீக்கு",
  "confirmations.delete.message": "இப்பதிவை நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
  "confirmations.delete_list.confirm": "நீக்கு",
  "confirmations.delete_list.message": "இப்பட்டியலை நிரந்தரமாக நீக்க நிச்சயம் விரும்புகிறீர்களா?",
  "confirmations.discard_edit_media.confirm": "நிராகரி",
  "confirmations.discard_edit_media.message": "சேமிக்கப்படாத மாற்றங்கள் ஊடக விளக்கம் அல்லது முன்னோட்டத்தில் உள்ளது. அவற்றை நிராகரிக்கவா?",
  "confirmations.logout.confirm": "வெளியேறு",
  "confirmations.logout.message": "நிச்சயமாக நீங்கள் வெளியேற விரும்புகிறீர்களா?",
  "confirmations.mute.confirm": "அமைதியாக்கு",
  "confirmations.redraft.confirm": "பதிவை நீக்கி மறுவரைவு செய்",
  "confirmations.unfollow.confirm": "விலகு",
  "conversation.delete": "உரையாடலை அழி",
  "conversation.mark_as_read": "படிக்கபட்டதாகக் குறி",
  "conversation.open": "உரையாடலைக் காட்டு",
  "conversation.with": "{names} உடன்",
  "directory.federated": "அறியப்பட்ட ஃபெடிவெர்சிலிருந்து",
  "directory.local": "{domain} களத்திலிருந்து மட்டும்",
  "directory.new_arrivals": "புதிய வரவு",
  "directory.recently_active": "சற்றுமுன் செயல்பாட்டில் இருந்தவர்கள்",
  "embed.instructions": "இந்தப் பதிவை உங்கள் வலைதளத்தில் பொதிக்கக் கீழே உள்ள வரிகளை காப்பி செய்யவும்.",
  "embed.preview": "பார்க்க இப்படி இருக்கும்:",
  "emoji_button.activity": "செயல்பாடு",
  "emoji_button.clear": "அழி",
  "emoji_button.custom": "தனிப்பயன்",
  "emoji_button.flags": "கொடிகள்",
  "emoji_button.food": "உணவு மற்றும் பானம்",
  "emoji_button.label": "எமோஜியை உள்ளிடு",
  "emoji_button.nature": "இயற்கை",
  "emoji_button.not_found": "எமோஜிக்கள் இல்லை! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "பொருட்கள்",
  "emoji_button.people": "மக்கள்",
  "emoji_button.recent": "அடிக்கடி பயன்படுத்தப்படுபவை",
  "emoji_button.search": "தேடு...",
  "emoji_button.search_results": "தேடல் முடிவுகள்",
  "emoji_button.symbols": "குறியீடுகள்",
  "emoji_button.travel": "சுற்றுலா மற்றும் இடங்கள்",
  "empty_column.account_suspended": "கணக்கு இடைநீக்கப்பட்டது",
  "empty_column.account_timeline": "டூட்டுகள் ஏதும் இல்லை!",
  "empty_column.account_unavailable": "சுயவிவரம் கிடைக்கவில்லை",
  "empty_column.blocks": "நீங்கள் இதுவரை எந்தப் பயனர்களையும் முடக்கியிருக்கவில்லை.",
  "empty_column.bookmarked_statuses": "உங்களிடம் அடையாளக்குறியிட்ட டூட்டுகள் எவையும் இல்லை. அடையாளக்குறியிட்ட பிறகு அவை இங்கே காட்டப்படும்.",
  "empty_column.community": "உங்கள் மாஸ்டடான் முச்சந்தியில் யாரும் இல்லை. எதையேனும் எழுதி ஆட்டத்தைத் துவக்குங்கள்!",
  "empty_column.domain_blocks": "தடுக்கப்பட்டக் களங்கள் இதுவரை இல்லை.",
  "empty_column.follow_requests": "வாசகர் கோரிக்கைகள் இதுவரை ஏதும் இல்லை. யாரேனும் கோரிக்கையை அனுப்பினால், அது இங்கே காண்பிக்கப்படும்.",
  "empty_column.hashtag": "இந்த சிட்டையில் இதுவரை ஏதும் இல்லை.",
  "empty_column.home": "உங்கள் மாஸ்டடான் வீட்டில் யாரும் இல்லை. {public} -இல் சென்று பார்க்கவும், அல்லது தேடல் கருவியைப் பயன்படுத்திப் பிற பயனர்களைக் கண்டடையவும்.",
  "empty_column.list": "இந்தப் பட்டியலில் இதுவரை ஏதும் இல்லை. இப்பட்டியலின் உறுப்பினர்கள் புதிய டூட்டுகளை இட்டால். அவை இங்கே காண்பிக்கப்படும்.",
  "empty_column.mutes": "நீங்கள் இதுவரை எந்தப் பயனர்களையும் முடக்கியிருக்கவில்லை.",
  "empty_column.notifications": "உங்களுக்காக எந்த அறிவிப்புகளும் இல்லை. உரையாடலைத் துவங்க பிறரைத் தொடர்புகொள்ளவும்.",
  "empty_column.public": "இங்கு எதுவும் இல்லை! இவ்விடத்தை நிரப்ப எதையேனும் எழுதவும், அல்லது வேறு சர்வர்களில் உள்ள பயனர்களைப் பின்தொடரவும்",
  "error.unexpected_crash.explanation": "இந்தப் பக்கத்தை சரியாகக் காண்பிக்க இயலவில்லை. மென்பொருளில் உள்ள பிழையோ அல்லது பொருந்தாத உலாவியோ காரணமாக இருக்கலாம்.",
  "error.unexpected_crash.next_steps": "பக்கத்தைப் புதுப்பித்துப் பார்க்கவும். அப்படியும் வேலை செய்யவில்லை எனில், மாஸ்டடானை வேறு ஒரு உலாவியின் மூலமோ, அல்லது பொருத்தமான செயலியின் மூலமோ பயன்படுத்திப் பார்க்கவும்.",
  "errors.unexpected_crash.copy_stacktrace": "Stacktrace-ஐ clipboard-ல் நகலெடு",
  "errors.unexpected_crash.report_issue": "புகாரளி",
  "explore.trending_links": "செய்திகள்",
  "explore.trending_statuses": "பதிவுகள்",
  "explore.trending_tags": "ஹேஷ்டேக்குகள்",
  "follow_request.authorize": "அனுமதியளி",
  "follow_request.reject": "நிராகரி",
  "follow_requests.unlocked_explanation": "உங்கள் கணக்கு பூட்டப்படவில்லை என்றாலும், இந்தக் கணக்குகளிலிருந்து உங்களைப் பின்தொடர விரும்பும் கோரிக்கைகளை நீங்கள் பரீசீலிப்பது நலம் என்று {domain} ஊழியர் எண்ணுகிறார்.",
  "generic.saved": "சேமிக்கப்பட்டது",
  "getting_started.heading": "முதன்மைப் பக்கம்",
  "hashtag.column_header.tag_mode.all": "மற்றும் {additional}",
  "hashtag.column_header.tag_mode.any": "அல்லது {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} தவிர்த்து",
  "hashtag.column_settings.select.no_options_message": "பரிந்துரைகள் ஏதும் இல்லை",
  "hashtag.column_settings.select.placeholder": "சிட்டைகளை உள்ளிடவும்…",
  "hashtag.column_settings.tag_mode.all": "இவை அனைத்தும்",
  "hashtag.column_settings.tag_mode.any": "இவற்றில் எவையேனும்",
  "hashtag.column_settings.tag_mode.none": "இவற்றில் ஏதுமில்லை",
  "hashtag.column_settings.tag_toggle": "இந்த நெடுவரிசையில் கூடுதல் சிட்டைகளைச் சேர்க்கவும்",
  "home.column_settings.show_reblogs": "பகிர்வுகளைக் காண்பி",
  "home.column_settings.show_replies": "மறுமொழிகளைக் காண்பி",
  "home.hide_announcements": "அறிவிப்புகளை மறை",
  "home.show_announcements": "அறிவிப்புகளைக் காட்டு",
  "intervals.full.days": "{number, plural, one {# நாள்} other {# நாட்கள்}}",
  "intervals.full.hours": "{number, plural, one {# மணிநேரம்} other {# மணிநேரங்கள்}}",
  "intervals.full.minutes": "{number, plural, one {# நிமிடம்} other {# நிமிடங்கள்}}",
  "keyboard_shortcuts.back": "பின் செல்ல",
  "keyboard_shortcuts.blocked": "தடுக்கப்பட்ட பயனர்கள் பட்டியலைத் திறக்க",
  "keyboard_shortcuts.boost": "பகிர",
  "keyboard_shortcuts.column": "ஏதேனும் ஒரு நெடுவரிசையில் உள்ள டூட்டுல் கவனம் செலுத்த",
  "keyboard_shortcuts.compose": "பதிவு எழுதும் பெட்டியில் கவனம் செலுத்த",
  "keyboard_shortcuts.description": "விவரம்",
  "keyboard_shortcuts.down": "பட்டியலின் கீழே செல்ல",
  "keyboard_shortcuts.enter": "டூட்டைத் திறக்க",
  "keyboard_shortcuts.federated": "மாஸ்டடான் ஆலமரத்தைத் திறக்க",
  "keyboard_shortcuts.heading": "விசைப்பலகை குறுக்குவழிகள்",
  "keyboard_shortcuts.home": "மாஸ்டடான் வீட்டைத் திறக்க",
  "keyboard_shortcuts.hotkey": "ஹாட் கீ",
  "keyboard_shortcuts.legend": "இந்த புராணத்தை காட்சிப்படுத்த",
  "keyboard_shortcuts.local": "உள்ளூர் காலவரிசை திறக்க",
  "keyboard_shortcuts.mention": "எழுத்தாளர் குறிப்பிட வேண்டும்",
  "keyboard_shortcuts.muted": "முடக்கப்பட்ட பயனர்களின் பட்டியலைத் திறக்க",
  "keyboard_shortcuts.my_profile": "உங்கள் சுயவிவரத்தை திறக்க",
  "keyboard_shortcuts.notifications": "அறிவிப்பு நெடுவரிசையைத் திறக்க",
  "keyboard_shortcuts.open_media": "படத்தைத் திறக்க‌",
  "keyboard_shortcuts.pinned": "திறக்க பொருத்தப்பட்டன toots பட்டியல்",
  "keyboard_shortcuts.profile": "ஆசிரியரின் சுயவிவரத்தைத் திறக்க",
  "keyboard_shortcuts.reply": "பதிலளிக்க",
  "keyboard_shortcuts.requests": "கோரிக்கைகள் பட்டியலைத் திறக்க",
  "keyboard_shortcuts.search": "தேடல் கவனம் செலுத்த",
  "keyboard_shortcuts.spoilers": "உள்ளடக்க எச்சரிக்கை செய்தியைக் காட்ட/மறைக்க",
  "keyboard_shortcuts.start": "'தொடங்குவதற்கு' நெடுவரிசை திறக்க",
  "keyboard_shortcuts.toggle_hidden": "CW க்கு பின்னால் உரையை மறைக்க / மறைக்க",
  "keyboard_shortcuts.toggle_sensitivity": "படிமங்களைக் காட்ட/மறைக்க",
  "keyboard_shortcuts.toot": "தொடங்க ஒரு புதிய toot",
  "keyboard_shortcuts.unfocus": "உரை பகுதியை / தேடலை கவனம் செலுத்த வேண்டும்",
  "keyboard_shortcuts.up": "பட்டியலில் மேலே செல்ல",
  "lightbox.close": "நெருக்கமாக",
  "lightbox.next": "அடுத்த",
  "lightbox.previous": "சென்ற",
  "lists.delete": "பட்டியலை நீக்கு",
  "lists.edit": "பட்டியலை திருத்து",
  "load_pending": "{count, plural,one {# புதியது}other {# புதியவை}}",
  "navigation_bar.blocks": "தடுக்கப்பட்ட பயனர்கள்",
  "navigation_bar.bookmarks": "அடையாளக்குறிகள்",
  "navigation_bar.domain_blocks": "மறைந்த களங்கள்",
  "navigation_bar.filters": "முடக்கப்பட்ட வார்த்தைகள்",
  "navigation_bar.follow_requests": "கோரிக்கைகளை பின்பற்றவும்",
  "navigation_bar.follows_and_followers": "பின்பற்றல்கள் மற்றும் பின்பற்றுபவர்கள்",
  "navigation_bar.lists": "குதிரை வீர்ர்கள்",
  "navigation_bar.logout": "விடு பதிகை",
  "navigation_bar.mutes": "முடக்கப்பட்ட பயனர்கள்",
  "navigation_bar.preferences": "விருப்பங்கள்",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} உங்களைப் பின்தொடர்கிறார்",
  "notification.follow_request": "{name} உங்களைப் பின்தொடரக் கோருகிறார்",
  "notification.own_poll": "கருத்துக்கணிப்பு நிறைவடைந்தது",
  "notification.reblog": "{name} உங்கள் நிலை அதிகரித்தது",
  "notifications.clear": "அறிவிப்புகளை அழிக்கவும்",
  "notifications.clear_confirmation": "உங்கள் எல்லா அறிவிப்புகளையும் நிரந்தரமாக அழிக்க விரும்புகிறீர்களா?",
  "notifications.column_settings.alert": "டெஸ்க்டாப் அறிவிப்புகள்",
  "notifications.column_settings.follow": "புதிய பின்பற்றுபவர்கள்:",
  "notifications.column_settings.follow_request": "புதிய பின்தொடர் கோரிக்கைகள்:",
  "notifications.column_settings.mention": "குறிப்பிடுகிறது:",
  "notifications.column_settings.poll": "கருத்துக்கணிப்பு முடிவுகள்:",
  "notifications.column_settings.push": "தள் அறிவிப்புகள்",
  "notifications.column_settings.reblog": "மதிப்பை உயர்த்து:",
  "notifications.column_settings.show": "பத்தியில் காண்பி",
  "notifications.column_settings.sound": "ஒலி விளையாட",
  "notifications.column_settings.status": "New toots:",
  "notifications.filter.all": "எல்லா",
  "notifications.filter.boosts": "மதிப்பை உயர்த்து",
  "notifications.filter.follows": "பின்பற்று",
  "notifications.filter.mentions": "குறிப்பிடுகிறார்",
  "notifications.filter.polls": "கருத்துக்கணிப்பு முடிவுகள்",
  "notifications.group": "{count} அறிவிப்புகள்",
  "poll.closed": "மூடிய",
  "poll.refresh": "பத்துயிர்ப்ப?ட்டு",
  "poll.total_people": "{count, plural, one {# நபர்} other {# நபர்கள்}}",
  "poll.total_votes": "{count, plural, one {# vote} other {# votes}}",
  "poll.vote": "வாக்களி",
  "poll.voted": "உங்கள் தேர்வு",
  "poll_button.add_poll": "வாக்கெடுப்பைச் சேர்க்கவும்",
  "poll_button.remove_poll": "வாக்கெடுப்பை அகற்று",
  "privacy.change": "நிலை தனியுரிமை",
  "privacy.public.short": "பொது",
  "refresh": "புதுப்பி",
  "relative_time.days": "{number}நா",
  "relative_time.hours": "{number}ம",
  "relative_time.just_now": "இப்பொழுது",
  "relative_time.minutes": "{number}நி",
  "relative_time.seconds": "{number}வி",
  "relative_time.today": "இன்று",
  "reply_indicator.cancel": "எதிராணை",
  "report.forward": "முன்னோக்கி {target}",
  "report.forward_hint": "கணக்கு மற்றொரு சேவையகத்திலிருந்து வருகிறது. அறிக்கையின் அநாமதேய பிரதி ஒன்றை அனுப்பவும்.?",
  "report.placeholder": "கூடுதல் கருத்துரைகள்",
  "report.submit": "சமர்ப்பி",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "தேடு",
  "search_results.hashtags": "ஹாஷ்டேக்குகளைச்",
  "search_results.statuses": "டூட்டுகள்",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_account": "மிதமான இடைமுகத்தை திறக்க @{name}",
  "status.admin_status": "மிதமான இடைமுகத்தில் இந்த நிலையை திறக்கவும்",
  "status.block": "@{name} -ஐத் தடு",
  "status.bookmark": "அடையாளம் குறி",
  "status.cancel_reblog_private": "இல்லை பூஸ்ட்",
  "status.cannot_reblog": "இந்த இடுகை அதிகரிக்க முடியாது",
  "status.copy": "நிலைக்கு இணைப்பை நகலெடு",
  "status.delete": "நீக்கு",
  "status.detailed_status": "விரிவான உரையாடல் காட்சி",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "அதிகமாய் ஏற்று",
  "status.media_hidden": "மீடியா மறைக்கப்பட்டது",
  "status.mention": "குறிப்பிடு @{name}",
  "status.more": "அதிக",
  "status.mute": "ஊமையான @{name}",
  "status.mute_conversation": "ஒலிதடு உரையாடல்",
  "status.open": "இந்த நிலையை விரிவாக்கு",
  "status.pin": "சுயவிவரத்தில் முள்",
  "status.read_more": "மேலும் வாசிக்க",
  "status.reblog": "மதிப்பை உயர்த்து",
  "status.reblogged_by": "{name} மதிப்பை உயர்த்து",
  "status.reblogs.empty": "இதுவரை யாரும் இந்த மோதலை அதிகரிக்கவில்லை. யாராவது செய்தால், அவர்கள் இங்கே காண்பார்கள்.",
  "status.redraft": "நீக்கு மற்றும் மீண்டும் வரைவு",
  "status.remove_bookmark": "அடையாளம் நீக்கு",
  "status.reply": "பதில்",
  "status.replyAll": "நூலுக்கு பதிலளிக்கவும்",
  "status.report": "@{name} மீது புகாரளி",
  "status.sensitive_warning": "உணர்திறன் உள்ளடக்கம்",
  "status.share": "பங்கிடு",
  "status.show_less_all": "அனைத்தையும் குறைவாக காட்டு",
  "status.show_more_all": "அனைவருக்கும் மேலும் காட்டு",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.unmute_conversation": "ஊமையாக உரையாடல் இல்லை",
  "status.unpin": "சுயவிவரத்திலிருந்து நீக்கவும்",
  "tabs_bar.home": "முகப்பு",
  "tabs_bar.notifications": "அறிவிப்புகள்",
  "time_remaining.days": "{number, plural, one {# day} மற்ற {# days}} left",
  "time_remaining.hours": "{number, plural, one {# hour} மற்ற {# hours}} left",
  "time_remaining.minutes": "{number, plural, one {# minute} மற்ற {# minutes}} left",
  "time_remaining.moments": "தருணங்கள் மீதமுள்ளன",
  "time_remaining.seconds": "{number, plural, one {# second} மற்ற {# seconds}} left",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "இப்போது செல்திசையில் இருப்பவை",
  "ui.beforeunload": "நீங்கள் வெளியே சென்றால் உங்கள் வரைவு இழக்கப்படும் மஸ்தோடோன்.",
  "upload_area.title": "பதிவேற்ற & இழுக்கவும்",
  "upload_button.label": "மீடியாவைச் சேர்க்கவும் (JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_error.limit": "கோப்பு பதிவேற்ற வரம்பு மீறப்பட்டது.",
  "upload_error.poll": "கோப்பு பதிவேற்றம் அனுமதிக்கப்படவில்லை.",
  "upload_form.edit": "தொகு",
  "upload_progress.label": "ஏற்றுகிறது ...",
  "video.close": "வீடியோவை மூடு",
  "video.download": "கோப்பைப் பதிவிறக்கவும்",
  "video.exit_fullscreen": "முழு திரையில் இருந்து வெளியேறவும்",
  "video.expand": "வீடியோவை விரிவாக்கு",
  "video.fullscreen": "முழுத்திரை",
  "video.hide": "வீடியோவை மறை",
  "video.pause": "இடைநிறுத்து",
  "video.play": "விளையாடு"
}
